// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1m6rH","title":"AfterFrontImage_title__2H6Uk"};